import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  
  return (
    <DashboardLayout userRole={user?.role}>
      <Outlet />
    </DashboardLayout>
  );
};

export default Dashboard;